'use client';

import { Else, If, Then } from 'react-if';
import { PaymentFormProvider } from '../paymentForm';
import { PlanTitle } from './atoms';
import { PaymentLoading, PaymentPeriodRadio, PaymentSummary, PlanCheckoutPayment, PlanCheckoutSpace, PlanSelectMaxCcu, SpacePlanSelectButtons, SubscriptionPaymentSteps } from './components';
import { useSubscriptionPaymentContext } from './hooks';
import S from './SubscriptionPayment.module.scss';
import { SubscriptionPaymentProvider, SubscriptionPaymentProviderProps } from './SubscriptionPaymentProvider';
const Content = () => {
  const {
    step
  } = useSubscriptionPaymentContext();
  return <>
      <PaymentLoading data-sentry-element="PaymentLoading" data-sentry-source-file="SubscriptionKrPayment.tsx" />
      <div className={S.wrapper}>
        <div className={S.container}>
          <div className={S.content}>
            <PlanTitle data-sentry-element="PlanTitle" data-sentry-source-file="SubscriptionKrPayment.tsx" />
            <SubscriptionPaymentSteps data-sentry-element="SubscriptionPaymentSteps" data-sentry-source-file="SubscriptionKrPayment.tsx" />

            <If condition={step === 1} data-sentry-element="If" data-sentry-source-file="SubscriptionKrPayment.tsx">
              <Then data-sentry-element="Then" data-sentry-source-file="SubscriptionKrPayment.tsx">
                <PaymentPeriodRadio data-sentry-element="PaymentPeriodRadio" data-sentry-source-file="SubscriptionKrPayment.tsx" />
                {/* 플랜 인원 선택 */}
                <PlanSelectMaxCcu data-sentry-element="PlanSelectMaxCcu" data-sentry-source-file="SubscriptionKrPayment.tsx" />
                <SpacePlanSelectButtons data-sentry-element="SpacePlanSelectButtons" data-sentry-source-file="SubscriptionKrPayment.tsx" />
                {/* 플랜 적용 스페이스 */}
                <PlanCheckoutSpace data-sentry-element="PlanCheckoutSpace" data-sentry-source-file="SubscriptionKrPayment.tsx" />
              </Then>
              <Else data-sentry-element="Else" data-sentry-source-file="SubscriptionKrPayment.tsx">
                <PlanCheckoutPayment data-sentry-element="PlanCheckoutPayment" data-sentry-source-file="SubscriptionKrPayment.tsx" />
              </Else>
            </If>
          </div>
          <div className={S.action}>
            <PaymentSummary data-sentry-element="PaymentSummary" data-sentry-source-file="SubscriptionKrPayment.tsx" />
          </div>
        </div>
      </div>
    </>;
};
export const SubscriptionKrPayment = (props: SubscriptionPaymentProviderProps) => {
  return <PaymentFormProvider data-sentry-element="PaymentFormProvider" data-sentry-component="SubscriptionKrPayment" data-sentry-source-file="SubscriptionKrPayment.tsx">
      <SubscriptionPaymentProvider {...props} data-sentry-element="SubscriptionPaymentProvider" data-sentry-source-file="SubscriptionKrPayment.tsx">
        <Content data-sentry-element="Content" data-sentry-source-file="SubscriptionKrPayment.tsx" />
      </SubscriptionPaymentProvider>
    </PaymentFormProvider>;
};